import React from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { NoData } from "../../../components/NoData";
import { useSelector } from "../../../store/hooks";
import { formatDateString } from "../../../utils/utils";
import { Label, Row } from "./RecommendationPanel";

export const ImplementationDateInsurer = () => {
  const { t } = useTranslation();
  const loadRecommendationStatus = useSelector(
    (s) => s.recommendationPanel.loadRecommendationStatus
  );
  const recommendation = useSelector(
    (s) => s.recommendationPanel.recommendation
  );
  const isLoading = loadRecommendationStatus === "loading";

  let render;
  if (isLoading) render = <Skeleton width={150} />;
  else if (!recommendation || !recommendation.implementationDateInsurer)
    render = <NoData />;
  else render = formatDateString(recommendation.implementationDateInsurer);

  return (
    <Row>
      <Label>
        {t("ram.recommendationForm.implementationDateInsurer.label")}:
      </Label>
      {render}
    </Row>
  );
};
